import React, { useState, useEffect } from 'react';
import {
  useGetAllAssessmentMutation,
  usePostEditAssessmentMutation,
  usePostAssessmentMutation,
} from 'slices/get/assessment';
import useService from 'views/default/useService';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
  useRowSelect,
  useRowState,
} from 'react-table';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetAllCommonAdminInitialDataMutation } from 'slices/get/common';
import { format } from 'date-fns';


function useDayPlan(filters = {}) {
  const title = 'Day Plan';
  const description = 'Day Plan List';
  const [isOpenAddEditDeleteModal, setIsOpenAddEditDeleteModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [whichModal, setWhichModal] = useState('');
  const [editModalData, setEditModalData] = useState({});
  const location = useLocation();
  const currentPath = location.pathname;
  const history = useHistory()

  const [getAllAssessment] = useGetAllAssessmentMutation();
  const [postAssessment] = usePostAssessmentMutation();
  const [postEditAssessment] = usePostEditAssessmentMutation();
  const { checkAccessTime, fetchAccessToken } = useService();
  const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation()
  const [data, setData] = useState([]);
  const [loader,setLoader] = useState(false)
  const [reloadFlag, setReloadFlag] = useState(0);
  // const queryParams = new URLSearchParams(location.search);
  // const subjectId = queryParams.get('subjectId');
  // const standardId = queryParams.get('standardId');
  // const seriesId = queryParams.get('seriesId');
  // const lessonId = queryParams.get('lessonId');

  // useEffect(() => {
  //   const access_token = fetchAccessToken();

  //   getAllCommonAdminInitialData({ ep: `/school/day_plans?subjectId=${subjectId}&seriesId=${seriesId}&standardId=${standardId}&lessonId=${lessonId}`, token: access_token }).then((response) => {
  //     if( response && response?.data && response?.data?.data && response?.data?.data?.length > 0){
  //     checkAccessTime(response, currentPath);
  //     setData(response.data.data);
  //     }
  //   });
  // }, []);
const { standardId, subjectId, seriesId, lessonId, sectionId } = filters;
  useEffect(() => {
    if (!filters.sectionId || !filters.seriesId || !filters.standardId || !filters.subjectId || !filters.lessonId) return; // don’t run until we have a valid filter
  
    const access_token = fetchAccessToken();
    setLoader(true)
    let url = `/school/day_plans?`;
    if (standardId) url += `standardId=${standardId}&`;
    if (subjectId) url += `subjectId=${subjectId}&`;
    if (seriesId) url += `seriesId=${seriesId}&`;
    if (lessonId) url += `lessonId=${lessonId}&`;
    if (sectionId) url += `sectionId=${sectionId}&`;
  
    getAllAssessment({ ep: url, token: access_token }).then((response) => {
      if (response?.data?.data?.length > 0) {
        checkAccessTime(response, currentPath);
        setData(response.data.data);
        setLoader(false)
      } else {
        setData([]);
        setLoader(false)
      }
    });
  }, [filters,,reloadFlag]);
  const refresh = () => {
    setReloadFlag((prev) => prev + 1);
  };
  const columns = React.useMemo(() => {
    return [
      {
        Header: 'School',
        accessor: 'school_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Standard',
        accessor: 'standard_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Section',
        accessor: 'section_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      
      {
        Header: 'Lesson',
        accessor: 'lesson_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },

      {
        Header: 'Day',
        accessor: 'day',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Plan',
        accessor: 'plan',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-30',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Status',
        accessor: 'active',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return (
            <Badge bg={`outline-${cell.value === 'on' ? 'primary' : 'danger'}`}>{cell.value}</Badge>
          );
        },
      },
      {
        Header: '',
        id: 'action',
        headerClassName: 'empty w-10',
        Cell: ({ row }) => {
          const { checked, onChange } = row.getToggleRowSelectedProps();
          return (
            <Form.Check
              className="form-check float-end mt-1"
              type="checkbox"
              checked={checked}
              onChange={onChange}
            />
          );
        },
      },
    ];
  }, []);

  const onOpenAddModal = () => {
    setIsOpen(true);
    setWhichModal('add');
  };

  const onOpenEditModal = (val) => {
    setIsOpen(true);
    setWhichModal('edit');
    setEditModalData(val);
  };

  const onOpenViewModal = (val) => {
    // console.log('tableInstance..........',tableInstance.selectedFlatRows[0].original.id)
    // let id = tableInstance.selectedFlatRows[0].original.id
    // history.push({
    //   pathname: `/assessment/quesions/${id}`,
    //   state: { 
    //     id, // Passing the id to the next component
    //     value: tableInstance.selectedFlatRows[0].original // You can pass more data like val here if needed
    //   }
    // });
    // let location = useLocation()
    // location.push('./assessmentQuetion')
    setIsOpen(true);
    setWhichModal('view');
    setEditModalData(val);
  };

  const onCloseEmptyModal = () => {
    setIsOpen(false);
    setWhichModal('');
    setEditModalData({});
  };

  const onCloseAddModal = async (values) => {
    onCloseEmptyModal();

    // setIsLoading(true);

    const access_token = fetchAccessToken();

    postAssessment({ ep: '/assessment/submit-form', values, token: access_token }).then(
      (response) => {
       

        checkAccessTime(response, currentPath);
        setData(response.data.data);
      }
    );
  };

  const onCloseEditModal = async (values) => {
    onCloseEmptyModal();

    // setIsLoading(true);

    const access_token = fetchAccessToken();

    postEditAssessment({ ep: '/assessment/submit-edit-form', values, token: access_token }).then(
      (response) => {
        // console.log(response);
        // console.log('Custom data from after_request:', response, response?.error);
        checkAccessTime(response, currentPath);
        setData(response.data.data);
      }
    );
  };

  const onCloseDeleteModal = async (values) => {

    // setIsLoading(true);
    let deletedIds = values.map(each=>each.id)
    const access_token = fetchAccessToken();

    postEditAssessment({
      ep: '/school/day_plans_delete',
      values: { dayPlanIds: deletedIds },
      token: access_token,
    }).then((response) => {
      console.log(response)
      // onCloseAddModal();
      window.location.reload();
      checkAccessTime(response, currentPath);
      // setData(response.data.data);
      onCloseEmptyModal();
    });
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      isOpenAddEditDeleteModal,
      setIsOpenAddEditDeleteModal,
      isOpen,
      setIsOpen,
      whichModal,
      setWhichModal,
      editModalData,
      setEditModalData,
      editModalData,
      setEditModalData,
      onOpenAddModal,
      onOpenEditModal,
      onOpenViewModal,
      onCloseEmptyModal,
      onCloseAddModal,
      onCloseEditModal,
      onCloseDeleteModal,
      filters,
      loader,
      refresh,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    useRowState
  );

  return { title, description, data, tableInstance };
}

export default useDayPlan;
